<template>
  <v-layout column class="ma-0 pa-0">
    <v-card class="mx-auto" flat width="100%">
      <v-card-title
        class="headline font-weight-regular text-uppercase justify-space-between primary--text"
        >{{ topic.name }}
        <v-spacer></v-spacer>
        <v-icon class="primary--text" @click="goBack()" x-large
          >icons8-back-arrow-2</v-icon
        >
      </v-card-title>
      <v-divider class="secondary mx-4"></v-divider>

      <v-card-text>
        <video width="100%" height="450" :src="topic.videoURL" controls disablePictureInPicture controlsList="nodownload"></video>

        <!--Tab Resources -->
        <v-tabs v-model="tab" background-color="primary" center-active fixed-tabs show-arrows dark>
          <v-tab v-for="(tabName) in filterResourcesTabs" :key="tabName.tab">{{tabName}} </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab"> 
          <v-tab-item v-for="i in resourceTabList" :key=i>
            <!--resources-list-->
            <v-list three-line >
              <v-row >
                <v-col  v-for="(item,index) in fitlerResourcesPerTab" :key="index.tab" cols="12" xs="12" sm="12" md="6">
                  <v-list-item  @click="showResources(item)">
                    <v-list-item-avatar size="55"><v-icon class="primary white--text" large>{{returnResourceIcon(item.resourceType)}}</v-icon></v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-html="item.resourceName"></v-list-item-title>
                      <v-list-item-subtitle v-if="item.resourceType != 'html' && item.resourceType != 'link'" v-html="item.resourceDescription"></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider :key="index" inset></v-divider>
                </v-col>
              </v-row>
            </v-list>
            <!--/resources-list-->
          </v-tab-item>
        </v-tabs-items>        
      </v-card-text>
    </v-card>

    <!--resource-dialog-->
    <v-dialog v-model="reosurceDialog">
      <v-card min-height="400">
        <v-card-title><p class="headline font-weight-regular text-uppercase justify-space-between primary--text">{{ openedObject.resourceName }}</p>
          <v-spacer></v-spacer>
          <v-btn class="secondary mr-3" v-if="openedObject.downloadable && openedObject.resourceType != 'link' && openedObject.resourceType != 'html'" @click="downloadResource(openedObject.url, openedObject.resourceName,openedObject.resourceType)">Download</v-btn>
          <v-btn class="primary" fab @click="closeResource()"><v-icon class="white--text">icons8-delete</v-icon></v-btn>
        </v-card-title>
        <v-divider class="secondary"></v-divider>
        <div v-if="openedObject.resourceType === 'pdf'">
          <!-- pdf -->
          <!-- // ! Had to replace PDF Viewer with Iframe for multipage -->
          <template>
            <iframe style="width:100%;height:600px;"  :src="openedObject.url+'#toolbar=0'">
              <template slot="loading">Please wait, content loading...</template>
            </iframe>
          </template>
        </div>
        <div class="py-4 px-6" v-else-if="openedObject.resourceType === 'image'" >
          <!-- image -->
          <v-img class="img" aspect-ratio="16/9" height="600" contain :src="openedObject.url"></v-img>
        </div>
        <div class="py-4 px-6" v-else-if="openedObject.resourceType === 'video'">
          <!-- video -->
          <video
            width="100%"
            height="450"
            v-if="openedObject.downloadable===false"
            :src="openedObject.url"
            controls
            disablePictureInPicture
            controlsList="nodownload"
          ></video>
          <video
            width="100%"
            height="450"
            v-else-if="openedObject.downloadable===true"
            :src="openedObject.url"
            controls
          ></video>
        </div>
        <div class="pa-4" v-else-if="openedObject.resourceType === 'html'">
          <!-- html -->
          <pre>{{ openedObject.resourceDescription }}</pre>
        </div>
        <div class="pa-4" v-else-if="openedObject.resourceType === 'link'">
          <!-- link -->
          <p>
            Please see the link to the resource below, please be aware that
            ThinkAir do not have any control over external resources.
          </p>
          <a :href="openedObject.resourceDescription" target="_blank">{{
            openedObject.resourceDescription
          }}</a>
        </div>
      </v-card>
    </v-dialog>
    <!--/resource-dialog-->
  </v-layout>
</template>

<script>
//import pdf from "vue-pdf"; // ! RG - REMOVED AND REPLACED WITH IFRAME
import axios from "axios";

export default {
  name: "TopicPage",
  data: () => ({
    topic: [],
    resources: [],
    reosurceDialog: false,
    tab:null,
    openedObject: [],
    filestackAPI: [],
    resourceTabList:[],
    resourcePerTab:[],
  }),
  computed: {
   filterResourcesTabs(){
    //  console.log('resources: ' + JSON.stringify(this.resources, null, 2))
    for (var i=0; i< this.resources.length; i++){
      if(this.resourceTabList.indexOf(this.resources[i].tabSelection)=== -1){
        this.resourceTabList.push(this.resources[i].tabSelection)
      }
    }
    // console.log(JSON.stringify(this.resourceTabList,null,2));
    return this.resourceTabList.sort();
  },
  fitlerResourcesPerTab(){
    var filterResources=[];
        for (var i=0; i< this.resources.length; i++){
              if(this.resourceTabList[this.tab]=== this.resources[i].tabSelection){
                filterResources.push(this.resources[i]);
              }
        }
        return filterResources;
  },
    filteredResources() {
      var today = this.$moment().toISOString();
      var self = this;
      // add available from query
      this.resources = this.resources.filter((item) => {
              console.log("RESOURCES PRIO " + item.resourceName)

        switch (true) {
          case self.$moment(item.availableFrom).toISOString() <= today && self.$moment(item.availableTo).toISOString() >= today:
            // console.log("ITEM " + JSON.stringify(item,null,2) )
            return item;
            break;
          case item.availableFrom === '' && item.availableTo === '':
                        // console.log("ITEM " + JSON.stringify(item,null,2) )

            return item;
            break;

        }
        
        // ! RG This needs to be case statement see above
        // if (
        //   self.$moment(item.availableFrom).toISOString() <= today &&
        //   self.$moment(item.availableTo).toISOString() >= today
        // ) {
        //   return item;
        // }
      });

      return this.resources;
    },
  },
  methods: {
     
    readTopic() {
      var self = this;
      self.topic = [];
      var docID = this.$route.params.id; // get ID from Route

      this.$firebase.db
        .collection("topics")
        .doc(docID)
        .get()
        .then(function(doc) {
          if (doc.exists) {
            //console.log("Document data:", doc.data());
            self.topic = doc.data();
          } else {
            // doc.data() will be undefined in this case
           // console.log("No such document!");
          }
        })
        .catch(function(error) {
         // console.log("Error getting document:", error);
        });
    },
    readTopicResources() {
      var self = this;
      self.resources = [];
      var docID = this.$route.params.id;
      var Data = [];
      this.$firebase.db
        .collection("resources")
        .where("topicId", "==", docID)
        .where("status", "==", "Published")
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            // doc.data() is never undefined for query doc snapshots
            Data = doc.data();
            Data.id = doc.id;
            self.resources.push(Data);
          });
        })
        .catch(function(error) {
       //   console.log("Error getting documents: ", error);
        });
    },

    returnResourceIcon(type) {
      switch (type) {
        case "pdf":
          return "icons8-pdf";
        case "html":
          return "icons8-html-filetype";
        case "image":
          return "icons8-image";
        case "video":
          return "icons8-video";
        case "link":
          return "icons8-link-4";
        case "excel":
          return "icons8-microsoft-excel";
        case "word":
          return "icons8-word";
        case "powerpoint":
          return "icons8-powerpoint";
      }
    },
    showResources(resource) {
      this.openedObject = resource;
      //console.log("this.openedObject = " + JSON.stringify(this.openedObject, null, 2)) // ! Added by Ryan
      this.reosurceDialog = true;
    },
    closeResource() {
      this.openedObject = [];
      this.reosurceDialog = false;
    },
    readFilestackAPI() {
      var self = this;
      self.filestackAPI = [];

      var Data = [];

      this.$firebase.db
        .collection("integrations")
        .where("integrationName", "==", "fsapikey")
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            // doc.data() is never undefined for query doc snapshots
            Data = doc.data();
            Data.id = doc.id;
            self.filestackAPI.push(Data);
          });
        })
        .catch(function(error) {
        //  console.log("Error getting documents: ", error);
        });
    },
    getFileType(type) {
      switch (type) {
        case "pdf":
          return "application/pdf";
        case "image":
          return "image/jpeg";
        case "video":
          return "video/mpeg";
        case "html":
          return "text/html";
        case "word":
          return "application/msword";
        case "excel":
          return "application/vnd.ms-excel";
        case "powerpoint":
          return "application/vnd.ms-powerpoint";
      }
    },
    downloadResource(url, label, rType) {
      var storage = this.$firebase.storage;
    var gsReference = storage.refFromURL(url)
    gsReference.getDownloadURL().then(function(url) {
      // This can be downloaded directly:
      var xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function(event) {
        var blob = xhr.response;
      };
      xhr.open('GET', url);
      xhr.send();

    }).catch(function(error) {
      // A full list of error codes is available at
      // https://firebase.google.com/docs/storage/web/handle-errors
      switch (error.code) {
        case 'storage/object-not-found':
          console.log('storage/object-not-found')
          break;

        case 'storage/unauthorized':
          console.log('storage/unauthorized')
          break;

        case 'storage/canceled':
          console.log('storage/canceled')
          break;

        case 'storage/unknown':
          console.log('storage/unknown')
          break;
      }  
    });
    //  var fType = this.getFileType(rType);
    //   axios
    //     .get(url, { responseType: "blob" })
    //     .then((response) => {
    //       console.log('in here')
    //       const blob = new Blob([response.data], { type: fType });
    //       const link = document.createElement("a");
    //       link.href = URL.createObjectURL(blob);
    //       link.download = label;
    //       link.click();
    //       URL.revokeObjectURL(link.href);
    //     })
    //     .catch(console.error);
    },
    goBack() {
      this.$router.push("/").catch((err) => {});
    },
  },
  created() {
    this.readFilestackAPI();
    this.readTopic();
    this.readTopicResources();
  },
  mounted() {
    // disable right-click/ save as in topics page to protect resources
    if (document.addEventListener) {
      document.addEventListener(
        "contextmenu",
        function(e) {
        //  console.log("You've tried to open context menu");
          e.preventDefault();
        },
        false
      );
    } else {
      document.attachEvent("oncontextmenu", function() {
      //  console.log("You've tried to open context menu");
        window.event.returnValue = false;
      });
    }
  },
};
</script>

<style scoped>
img {
  pointer-events: none;
}
</style>
